import { StoreActions } from '.';
import {
  readPractice,
  verifyPractice,
  getPractices,
} from './../../api/practiceApi';

/*******************************
 * Private Functions
 *****************************/

/**
 * Set selected practice on search success
 * @param {*} practiceInfo
 */
function getLoggedPracticeInfo(practiceInfo = null) {
  return {
    type: StoreActions.GET_LOGGED_PRACTICE_INFO,
    practiceInfo,
  };
}

/**
 * Set practice status to active (upon) successful request
 */
function activatePracticeSuccess() {
  return {
    type: StoreActions.ACTIVATE_PRACTICE_SUCCESS,
  };
}

/**
 *
 * @param {*} practices
 */
function displayParcticeList(practices) {
  return {
    type: StoreActions.DISPLAY_PRACTICE_LIST_SUCCESS,
    practices,
  };
}

/*******************************
 * Esports
 *****************************/

/**
 * Set selected practice in Redux store
 * @param {*} id
 * @param {*} practiceList
 */
export function setSelectedPractice(id, practiceList) {
  const selectedPractice = practiceList.find((element) => element.id === id);
  return {
    type: StoreActions.SET_SELECTED_PRACTICE,
    selectedPractice,
  };
}

export function setSelectedPracticeByPractice(selectedPractice) {
  return {
    type: StoreActions.SET_SELECTED_PRACTICE,
    selectedPractice,
  };
}

/**
 * Reset initial state in Redux Store for selected practice
 */
export function unsetSelectedPractice() {
  return {
    type: StoreActions.UNSET_SELECTED_PRACTICE,
  };
}

/**
 * Edit selected practice in redux store
 * @param {*} selectedPractice
 * @param {*} propsToAlter
 */
export function alterSelectedPractice(selectedPractice, propsToAlter) {
  const alteredPractice = { ...selectedPractice, ...propsToAlter };
  return {
    type: StoreActions.ALTER_SELECTED_PRACTICE,
    alteredPractice,
  };
}

// Async Functions

/**
 * Read Practice from database by ID
 * @param {*} id
 */
export function getPracticeInfo(id) {
  return function (dispatch) {
    return readPractice(id)
      .then((res) => {
        dispatch(getLoggedPracticeInfo(res));
      })
      .catch((err) => {
        throw err;
      });
  };
}

/**
 * Get practice by id and set to the selected practice
 * @param {*} id
 */
export function getPracticeInfoForAdmin(id) {
  return function (dispatch) {
    return readPractice(id)
      .then((res) => {
        dispatch(setSelectedPracticeByPractice(res));
      })
      .catch((err) => {
        throw err;
      });
  };
}

/**
 * Set practice status to active and store to DB
 * @param {*} practice
 */
export function activatePractice(practice) {
  return function (dispatch) {
    return verifyPractice(practice)
      .then(() => {
        dispatch(activatePracticeSuccess());
        getPractices()
          .then((practices) => {
            dispatch(
              displayParcticeList(
                practices.sort((a, b) => {
                  if (a.name < b.name) return -1;
                  if (a.name > b.name) return 1;
                  else return 0;
                })
              )
            );
          })
          .catch((err) => {
            throw err;
          });
      })
      .catch((err) => {
        throw err;
      });
  };
}
